import { useNavigate } from "@tanstack/react-router";
import { Database } from "lucide-react";
import { EmptyState, InspectorSection, ResourceItem } from "./InspectorSection";

interface Resource {
  name: string;
  uri: string;
  mimeType?: string;
}

interface ResourcesSectionProps {
  resources: Resource[];
  projectId: string;
  isDeployed: boolean;
  isExpanded: boolean;
  onToggle: () => void;
}

export function ResourcesSection({
  resources,
  projectId,
  isDeployed,
  isExpanded,
  onToggle,
}: ResourcesSectionProps) {
  const navigate = useNavigate();

  const handleResourceNavigate = (uri: string) => {
    navigate({
      to: "/projects/$projectId",
      params: { projectId },
      search: {
        tab: "inspector",
        inspectorTab: "resources",
        selectedResource: uri,
      },
    });
  };

  const handleMoreResourcesNavigate = () => {
    navigate({
      to: "/projects/$projectId",
      params: { projectId },
      search: { tab: "inspector", inspectorTab: "resources" },
    });
  };

  return (
    <InspectorSection
      title="Resources"
      icon={Database}
      count={isDeployed ? resources.length : 0}
      isExpanded={isExpanded}
      onToggle={onToggle}
    >
      {isDeployed && resources.length > 0 ? (
        <>
          {resources.slice(0, 2).map((resource, index) => (
            <ResourceItem
              key={`${resource.uri}-${index}`}
              resource={resource}
              onNavigate={handleResourceNavigate}
            />
          ))}
          {resources.length > 2 && (
            <button
              type="button"
              onClick={handleMoreResourcesNavigate}
              className="text-xs text-muted-foreground hover:text-primary transition-colors text-center pt-1 w-full"
            >
              +{resources.length - 2} more resources available
            </button>
          )}
        </>
      ) : (
        <EmptyState
          icon={Database}
          message={
            !isDeployed
              ? "Deploy to discover resources"
              : "No resources available"
          }
        />
      )}
    </InspectorSection>
  );
}
